export enum SVGType {
    EVENT= 1,
    USER
}
